<template>
    <v-dialog width="1200px" v-model="isOpenCommunicateView">
        <v-card elevation="4">
            <v-card-title primary-title>
                <v-row>
                    <v-col cols="12" align="start">
                        <div
                            v-if="$vuetify.breakpoint.mdAndDown"
                            class="primary--text text-overline text-center"
                        >
                            {{ type == 'CREATE' ? 'Creando' : 'Visualizando' }}
                            un Comunicado
                        </div>
                        <div
                            v-else
                            class="
                                font-weight-light
                                primary--text
                                text-h5 text-capitalize
                                mt-n1
                            "
                        >
                            <v-icon large> mdi-smart-card-outline </v-icon>
                            {{ type == 'CREATE' ? 'Creando' : 'Visualizando' }}
                            un Comunicado
                        </div>
                    </v-col>
                </v-row>
                <v-row v-if="type != 'CREATE'" no-gutters>
                    <v-col
                        :class="
                            $vuetify.breakpoint.xsOnly
                                ? 'd-flex justify-center ml-n3'
                                : 'd-flex justify-end'
                        "
                    >
                        <div class="d-flex justify-center wrapper">
                            <svg
                                version="1.1"
                                id="Layer_1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                x="0px"
                                y="0px"
                                viewBox="0 0 98.5 98.5"
                                enable-background="new 0 0 98.5 98.5"
                                xml:space="preserve"
                            >
                                <path
                                    class="checkmark"
                                    fill="none"
                                    stroke-width="4"
                                    stroke-miterlimit="10"
                                    d="M81.7,17.8C73.5,9.3,62,4,49.2,4
							C24.3,4,4,24.3,4,49.2s20.3,45.2,45.2,45.2s45.2-20.3,45.2-45.2c0-8.6-2.4-16.6-6.5-23.4l0,0L45.6,68.2L24.7,47.3"
                                />
                            </svg>
                        </div>
                        <div
                            v-if="$vuetify.breakpoint.mdAndDown"
                            class="primary--text text-overline text-center"
                        ></div>
                        <div
                            v-else
                            class="
                                font-weight-light
                                primary--text
                                text-h5 text-capitalize
                                mt-n1
                                ml-2
                            "
                        >
                            Leído
                        </div>
                    </v-col>
                </v-row>
            </v-card-title>

            <v-card-text>
                <v-row dense v-if="comercialesFilter.length > 0">
                    <v-col md="3" cols="12" class="px-1">
                        <v-card outlined>
                            <v-row class="my-1 mx-1">
                                <h4
                                    class="font-weight-light primary--text px-2"
                                >
                                    Filtrar por Rol
                                </h4>
                            </v-row>
                            <v-divider class="mx-1"></v-divider>
                            <v-row no-gutters>
                                <v-select
                                    :disabled="type != 'CREATE'"
                                    class="px-4"
                                    :items="opciones.cuenta.rol"
                                    item-text="human"
                                    item-value="encoded"
                                    v-model="rol"
                                    persistent-hint
                                    :hint="
                                        rol.length
                                            ? 'Elimine los filtros para ver la selección completa'
                                            : ''
                                    "
                                    multiple
                                    prepend-inner-icon="mdi-gamepad-outline"
                                    label="Elija un rol"
                                    :clearable="type == 'CREATE'"
                                >
                                    <template #item="{ item }">
                                        {{ item.human }}
                                    </template>
                                    <template #selection="{ item }">
                                        <v-chip
                                            small
                                            dark
                                            color="red lighten-1"
                                            >{{ item.human }}</v-chip
                                        >
                                    </template>
                                </v-select>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-col md="3" cols="12" class="px-1">
                        <v-card outlined>
                            <v-row class="my-1 mx-1">
                                <h4
                                    class="font-weight-light primary--text px-2"
                                >
                                    Filtrar por Tipo
                                </h4>
                            </v-row>
                            <v-divider class="mx-1"></v-divider>
                            <v-row no-gutters>
                                <v-select
                                    :disabled="type != 'CREATE'"
                                    class="px-4"
                                    :items="opciones.cuenta.tipoComercial"
                                    item-text="human"
                                    item-value="encoded"
                                    v-model="types"
                                    persistent-hint
                                    :hint="
                                        types.length
                                            ? 'Elimine los filtros para ver la selección completa'
                                            : ''
                                    "
                                    multiple
                                    prepend-inner-icon="mdi-filter"
                                    label="Elija un tipo"
                                    :clearable="type == 'CREATE'"
                                >
                                    <template #item="{ item }">
                                        {{ item.human }}
                                    </template>
                                    <template #selection="{ item }">
                                        <v-chip
                                            small
                                            dark
                                            color="orange lighten-1"
                                            >{{ item.human }}</v-chip
                                        >
                                    </template>
                                </v-select>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-col md="6" cols="12" class="px-1">
                        <v-card outlined>
                            <v-row class="my-1 mx-1">
                                <h4
                                    class="font-weight-light primary--text px-2"
                                >
                                    Receptores del Comunicado
                                </h4>
                            </v-row>
                            <v-divider class="mx-1"></v-divider>
                            <v-row no-gutters>
                                <v-autocomplete
                                    :readonly="type != 'CREATE'"
                                    v-if="
                                        $store.getters[
                                            'login/hasManagerPermission'
                                        ]
                                    "
                                    class="px-4"
                                    :items="comercialesFilter"
                                    v-model="form.receivers"
                                    item-text="nombreCompleto"
                                    return-object
                                    multiple
                                    prepend-inner-icon="mdi-account"
                                    :hint="
                                        form.receivers.length + ' seleccionados'
                                    "
                                    persistent-hint
                                    label="Comercial"
                                    :clearable="type == 'CREATE'"
                                >
                                    <template #item="{ item }">
                                        <v-row>
                                            <v-col cols="9">
                                                {{ item.nombreCompleto }}
                                            </v-col>
                                            <v-col cols="3">
                                                <v-icon
                                                    :color="
                                                        item.estado == 'ALTA'
                                                            ? 'green'
                                                            : 'red'
                                                    "
                                                >
                                                    mdi-circle
                                                </v-icon>
                                            </v-col>
                                        </v-row>
                                    </template>
                                    <template #selection="{ item }">
                                        <v-chip small color="lime">{{
                                            item.nombreCompleto
                                        }}</v-chip>
                                    </template>
                                </v-autocomplete>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" md="9" class="px-1">
                        <v-card outlined>
                            <v-row class="my-1 mx-1">
                                <h4
                                    class="font-weight-light primary--text px-2"
                                >
                                    Título
                                </h4>
                            </v-row>
                            <v-divider class="mx-1"></v-divider>
                            <v-row no-gutters>
                                <v-text-field
                                    :readonly="type != 'CREATE'"
                                    class="mx-4"
                                    v-model="form.message_title"
                                    label="Encabezado del Mensaje"
                                    :clearable="type == 'CREATE'"
                                ></v-text-field>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="3" class="px-1">
                        <v-card outlined>
                            <v-row class="my-1 mx-1">
                                <h4
                                    class="font-weight-light primary--text px-2"
                                >
                                    Prioridad
                                </h4>
                            </v-row>
                            <v-divider class="mx-1"></v-divider>
                            <v-row no-gutters>
                                <v-select
                                    :readonly="type != 'CREATE'"
                                    class="px-4"
                                    :items="priorityChoices"
                                    item-text="human"
                                    item-value="encoded"
                                    v-model="form.priority"
                                    persistent-hint
                                    prepend-inner-icon="mdi-priority-high"
                                    label="Elija una prioridad"
                                    :clearable="type == 'CREATE'"
                                >
                                    <template #item="{ item }">
                                        {{ item.human }}
                                    </template>
                                    <template #selection="{ item }">
                                        <v-chip
                                            small
                                            dark
                                            color="red lighten-1"
                                            >{{ item.human }}</v-chip
                                        >
                                    </template>
                                </v-select>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" class="px-1">
                        <v-card outlined>
                            <v-row class="my-1 mx-1">
                                <h4
                                    class="font-weight-light primary--text px-2"
                                >
                                    Mensaje
                                </h4>
                            </v-row>
                            <v-divider class="mx-1"></v-divider>
                            <v-row no-gutters>
                                <v-textarea
                                    auto-grow
                                    :readonly="type != 'CREATE'"
                                    :clearable="type == 'CREATE'"
                                    class="mx-4"
                                    clear-icon="mdi-close-circle"
                                    v-model="form.message_body"
                                    :hint="
                                        form.message_body
                                            ? form.message_body.length +
                                              ' caracteres escritos'
                                            : ''
                                    "
                                    persistent-hint
                                ></v-textarea>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions class="justify-end pt-3">
                <v-btn
                    v-if="type == 'CREATE'"
                    :disabled="checkSubmitDisabled"
                    color="success"
                    @click="
                        submit();
                        close();
                    "
                >
                    Crear
                </v-btn>
                <v-btn text color="red" @click="close()"> Cerrar </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import defaultCommunicateForm from '@/util/rrhh/defaultCommunicateForm.js';
import { clone } from '@/util/libUtil.js';

export default {
    name: 'CommunicatesForm',
    data: () => ({
        cuentasAll: [],
        types: [],
        rol: [],
        priorityChoices: [
            {
                encoded: 'LOW',
                human: 'Baja',
            },
            {
                encoded: 'MIDDLE',
                human: 'Media',
            },
            {
                encoded: 'HIGH',
                human: 'Alta',
            },
        ],
    }),
    methods: {
        close() {
            this.form = clone(defaultCommunicateForm);
            this.isOpenCommunicateView = false;
        },
        submit() {
            this.$store.dispatch('rrhh/createCommunicates');
        },
        ...mapActions('rrhh', ['getCuentasTableData']),
    },
    computed: {
        checkSubmitDisabled() {
            return (
                Boolean(this.form.message_body) &&
                Boolean(this.form.message_title) &&
                this.form.receivers.length == 0
            );
        },
        comercialesFilter() {
            let activeCommercials = this.cuentasAll.filter(
                (comercial) => comercial.estado == 'ALTA'
            );
            return this.rol.length == 0 && this.types.length == 0
                ? activeCommercials
                : activeCommercials.filter(
                      (comercial) =>
                          this.rol.some((rol) => rol == comercial.rol?.id) ||
                          this.types.some(
                              (type) => type == comercial.tipoComercial
                          )
                  );
        },
        opciones() {
            return JSON.parse(localStorage.getItem('opciones'));
        },
        form: {
            get() {
                return this.$store.state.rrhh.communicates.form;
            },
            set(value) {
                this.$store.commit('rrhh/communicatesForm', value);
            },
        },
        isOpenCommunicateView: {
            get() {
                let isOpen =
                    this.$store.state.rrhh.communicates.isOpenCommunicateView;
                if (!isOpen) this.form = clone(defaultCommunicateForm);

                return isOpen;
            },
            set(value) {
                this.$store.commit('rrhh/isOpenCommunicateView', value);
            },
        },
        ...mapState('rrhh', {
            type: (state) => state.communicates.type,
        }),
        ...mapState('util', {
            exportingProgress: (state) => state.exportingProgress,
            isExporting: (state) => state.isExporting,
        }),
		...mapGetters('login', {
			hasAdminPermission: 'hasAdminPermission',
		}),
    },
    watch: {
        isOpenCommunicateView(value) {
            if (value && this.cuentasAll.length == 0 && this.hasAdminPermission) {
                this.getCuentasTableData(100).then((resp) => {
                    this.cuentasAll = resp.results;
                });
            }
        },
    },
};
</script>

<style scoped>
.wrapper {
    width: 28px;
    margin-left: 30px;
}

.checkmark {
    stroke: green;
    stroke-dashoffset: 745.74853515625;
    stroke-dasharray: 745.74853515625;
    animation: dash 2s ease-out forwards infinite;
}

@keyframes dash {
    0% {
        -dashoffset: 745.74853515625;
    }
    100% {
        stroke-dashoffset: 0;
    }
}
</style>